import { createActionVariableReceiver } from './receiver';
function parseMappedVariables(mappedVariables) {
    return Object.entries(mappedVariables)
        .map(([mappedVariable, value]) => {
        const [, parsedVariationId, parsedVariableName] = mappedVariable.match(/^__([0-9a-zA-Z]+)__(.+)/) ?? [];
        return [parsedVariationId, parsedVariableName, value];
    })
        .reduce((acc, [parsedVariationId, parsedVariableName, value]) => {
        if (!parsedVariationId || !parsedVariableName)
            return acc;
        if (!acc[parsedVariationId]) {
            acc[parsedVariationId] = {};
        }
        acc[parsedVariationId][parsedVariableName] = value;
        return acc;
    }, {});
}
export const createServerSideVariablesClient = ({ window, storageKey, }) => {
    const receiver = createActionVariableReceiver({
        window,
        storageKey,
    });
    async function getVariables({ variationId, usePreviousValue, }) {
        const actionVariables = usePreviousValue ? receiver.getPrev() : await receiver.getLatest();
        const variablesByVariations = parseMappedVariables(actionVariables);
        return variablesByVariations[variationId];
    }
    return {
        getVariables,
    };
};
